export default {"src":"/_next/static/media/Plus.684b5d60.svg","height":24,"width":24};